import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import { shallowEqual } from 'app-source/utils/shallowEqual';
import { TriviaChoicesComponent } from '../Choices';

const styles = {
  bold: {
    fontWeight: 800,
  },
  content: {
    paddingTop: 0,
    paddingBottom: 0,
  },
};

class TriviaFormContentComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    title: PropTypes.string,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    selectedValue: PropTypes.string,
    disabled: PropTypes.bool,
    handleChoiceSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: '',
    choices: [],
    selectedValue: null,
    disabled: false,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, title, choices, disabled, selectedValue, handleChoiceSelect } = this.props;

    return (
      <CardContent className={classes.content}>
        <TriviaChoicesComponent
          title={title}
          choices={choices}
          disabled={disabled}
          selectedValue={selectedValue}
          handleChoiceSelect={handleChoiceSelect}
        />
      </CardContent>
    );
  }
}

export const TriviaFormContent = withStyles(styles)(TriviaFormContentComponent);
